import { CommonModule } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit, Optional, ViewChild, ElementRef } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdministratorService } from '../../../services/administrator.service';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HrmsService } from '../../../services/hrms.service';
import { Employee, Reportee } from '../../../model/hrms/attendance.model';
import { gridPageRequest } from '../../../model/common/common.model';
import { MultiSelectModule } from 'primeng/multiselect';
import { FieldsetModule } from 'primeng/fieldset';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarModule } from 'primeng/calendar';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { SplitButtonModule } from 'primeng/splitbutton';
import confetti from 'canvas-confetti';
import { forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
export interface FileItem {
  id: number;
  name: string;
  type: 'pdf' | 'doc' | 'xls' | 'img' | 'zip' | 'video' | string;
  size: string;
  label?: string;
 
  url?: string;
  sharedBy?: string;
  fileId?: number;
  filePath?: string;
  uploadedAt: Date | null;
 
  submitted?: boolean;
  pendingFile?: File;
}
@Component({
  selector: 'app-home-dashboard',
  standalone: true,
  imports: [CommonModule, SharedModule, TabViewModule, ButtonModule, MultiSelectModule, FieldsetModule,
    CalendarModule, FullCalendarModule, SplitButtonModule, SharedModule, TagModule, FormsModule,
    ToastModule,
    ConfirmDialogModule,
    DialogModule,
  ],
  templateUrl: './home-hrmsdashboard.component.html',
  styleUrls: ['./home-hrmsdashboard.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class HRMSHomeDashboardComponent implements OnInit, OnDestroy {
  onFilesSelected($event: Event) { throw new Error('Method not implemented.'); }
  triggerFileUpload() { throw new Error('Method not implemented.'); }
  username: string = '';
  companyName: string = '';
  companyLogo: any;
  greeting = '';
  quote = '';
  empId: number = 0;
  activeTabIndex: number = 0;
  employeeId: string = '';
  loggedInEmployeeId: string = '';
  employeeName: string = '';
  Designation: string = '';
  shiftName: string = '';
  employeeList: any[] = [];
  shiftDropdown: any[] = [];
  reportees: Reportee[] = [];
  allExpenses: any[] = [];
  checkedIn = false;
  canCheckIn = true;
  canCheckOut = false;
  attendanceId: number | null = null;
  todayAttendance: any = null;
  AttendanceList: any[] = [];
  loader = false;
  private timer: any;
  hours = 0; minutes = 0; seconds = 0;
  currentWorkLocationType = '';
  currentLocationName = '';
  currentAttendanceStatus = '';
  isPendingApproval = false;
  todayLeaves: any[] = [];
  todayWFH: any[] = [];
  loadingLeaves = false;
  birthdayEmployees: any[] = [];
  isMyBirthdayToday = false;
  birthdaysToday: any[] = [];
  filteredBirthdays: any[] = [];
  isCheckingIn = false;
  expenseSearchKey: string = '';
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
  dashboardData: any = {
    ClaimAmount: 0,
    approvedAmount: 0,
    pending: 0,
    rejected: 0,
    Expense: 0
  };
  searchText: string = '';
  placeholder: string = 'Search Expense';
  selectedExpense: any[] = [];
  recentExpenses: any[] = [];
  birthdayOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Current Month', value: 'month' }
  ];
  selectedBirthdayFilter = 'today';
  layoutType: 'calendar' = 'calendar';
  selectedViewLabel = 'Calendar';
  viewOptions = [
    { label: 'Calendar', icon: 'pi pi-calendar', command: () => this.setView('calendar') }
  ];
  newAnnouncementsCount: number = 0;
  newSurveysCount: number = 0;
  newHolidaysCount: number = 0;
  announcements: any[] = [];
  surveys: any[] = [];
  holidays: any[] = [];
  mailAlerts: any[] = [];
  showDetailDialog = false;
  detailType: 'announcement' | 'survey' | 'holiday' | '' = '';
  detailItem: any = null;
  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    eventClick: (arg) => this.handleCalendarClick(arg),
    datesSet: this.onDatesSet.bind(this),
    events: [],
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    eventContent: (arg) => ({
      html: `<div class="fc-event-title">${arg.event.title}</div>`
    })
  };
  submitted = false;
  today: Date = new Date();
  stateList: any[] = [];
  filterStates: any[] = [];
  gender = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' }
  ];
  prefixOptions = [
    { label: 'Mr.', value: 'Mr.' },
    { label: 'Mrs.', value: 'Mrs.' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Dr.', value: 'Dr.' }
  ];
  employeeForm = new FormGroup({
    employeeId: new FormControl('', Validators.required),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl(''),
    type: new FormControl(''),
    address: new FormGroup({
      addressLine1: new FormControl(''),
      addressLine2: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl(''),
      country: new FormControl('India'),
    }),
    phone: new FormControl(''),
    mobile: new FormControl(''),
    prefix: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    designation: new FormControl(''),
    jobRole: new FormControl(''),
    work_Email: new FormControl(''),
    employmentType: new FormControl(''),
    employeeStatus: new FormControl(''),
    location: new FormControl(''),
    dateOfJoining: new FormControl<Date | null>(null),
    reportingManager: new FormControl<number[]>([]),
    gender: new FormControl(''),
    dob: new FormControl<Date | null>(null),
    website: new FormControl(''),
    facebook: new FormControl(''),
    twitter: new FormControl(''),
    instituteName: new FormControl(''),
    degree: new FormControl(''),
    specialization: new FormControl(''),
    completionYear: new FormControl(''),
    internalNotes: new FormControl(''),
    IsActive: new FormControl(true),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
    ShiftId: new FormControl<number | string | null>(null),
    ShiftName: new FormControl(''),
  });
  pageRequest: gridPageRequest = { pageIndex: 0, pageSize: 200, id: 0 };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialogService: DialogService,
    private administratorService: AdministratorService,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public config: DynamicDialogConfig,
    private messageService: MessageService,
    private hrmsService: HrmsService,
    private confirmationService: ConfirmationService,
    private zone: NgZone
  ) { }
  ngOnInit(): void {
    
    this.filteredMyFiles = [...this.myFiles];
    this.filteredSharedFiles = [...this.sharedFiles];
    document.title = 'HRMS Dashboard';
    const auth = JSON.parse(localStorage.getItem('auth') || '{}');
    this.username = auth?.user?.firstName || 'User';
    const userId = auth?.user?.id;
    this.setGreetingAndQuote();
    this.getCompanyDetails();
    this.loadTodayLeavesAndWFH();
    this.loadFeedsData();
    this.loadSubmittedState();
    this.hrmsService.getEmployees(this.pageRequest).subscribe({
      next: (res: any) => {
        const employees = res?.employees || [];
        this.employeeList = employees.map((emp: any) => ({
          label: `${emp.firstName} ${emp.lastName}`,
          value: emp.empId,
          designation: emp.designation
        }));
        this.loadBirthdayEmployees(employees);
      },
      error: err => console.error('Error fetching employee list:', err)
    });
    setInterval(() => this.handleDayChange(), 60 * 1000);
    setInterval(() => this.loadFeedsData(), 5 * 60 * 1000);
    this.route.queryParams.subscribe((params: any) => {
      if (params['tab']) {
        this.activeTabIndex = +params['tab'];
      }
    });
    if (userId) {
      this.resolveEmployeeFromUserId(userId);
    }
    this.route.queryParams.subscribe(params => {
      if (params['tab']) {
        this.activeTabIndex = +params['tab'];
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const isDashboard = event.url.includes('hrmsdashboard');
        if (isDashboard && this.loggedInEmployeeId) {
          this.loadExpenseDashboardData(this.loggedInEmployeeId);
          this.loadDashboardExpenses(this.loggedInEmployeeId);
        }
        if (isDashboard && event.url.includes('tab=3')) {
          setTimeout(() => {
            this.loadExpenseDashboardData(this.loggedInEmployeeId);
            this.loadDashboardExpenses(this.loggedInEmployeeId);
          }, 300);
        }
      }
    });
  }
  ngOnDestroy(): void {
    if (this.timer) clearInterval(this.timer);
  }
  loadFeedsData(): void {
    this.loadAnnouncementsForFeed();
    this.loadSurveysForFeed();
    this.loadHolidaysForFeed();
  }
  loadAnnouncementsForFeed(): void {
    this.hrmsService.getAnnouncements({ pageIndex: 1, pageSize: 100 }).subscribe({
      next: (res: any) => {
        const data: any[] = Array.isArray(res) ? res : res?.announcements ?? res?.data ?? [];
        const today = new Date(); today.setHours(0, 0, 0, 0);
        this.announcements = data
          .filter((a: any) => a.isPosted === true)
          .filter((a: any) => a.isActive)
          .filter((a: any) => { if (!a.expiryDate) return true; return new Date(a.expiryDate) >= today; })
          .map((a: any) => ({
            announcementId: a.announcementId,
            title: a.title,
            description: a.description ?? '',
            date: a.createdDate ? new Date(a.createdDate) : new Date(),
            expiryDate: a.expiryDate ? new Date(a.expiryDate) : null,
            category: a.targetAudience ?? 'General',
            attachment: a.attachment ?? null,
            createdBy: a.createdBy
          }));
        const seenIds: number[] = JSON.parse(localStorage.getItem('seenItems_announcement') || '[]');
        this.newAnnouncementsCount = this.announcements.filter(a => !seenIds.includes(a.announcementId)).length;
      },
      error: (err: any) => console.error('Load announcements for feed failed:', err)
    });
  }
  loadSurveysForFeed(): void {
    this.hrmsService.getSurveys({ pageIndex: 1, pageSize: 100 }).subscribe({
      next: (res: any) => {
        const data: any[] = Array.isArray(res) ? res : res?.surveys ?? res?.data ?? [];
        const today = new Date(); today.setHours(0, 0, 0, 0);
        this.surveys = data
          .filter((s: any) => s.isPosted === true)
          .filter((s: any) => s.isActive)
          .filter((s: any) => { if (!s.endDate) return true; return new Date(s.endDate) >= today; })
          .map((s: any) => ({
            surveyId: s.surveyId,
            title: s.surveyTitle,
            description: s.description ?? '',
            startDate: s.startDate ? new Date(s.startDate) : null,
            dueDate: s.endDate ? new Date(s.endDate) : null,
            status: this.getSurveyStatus(s.startDate, s.endDate),
            createdBy: s.createdBy
          }));
        const seenIds: number[] = JSON.parse(localStorage.getItem('seenItems_survey') || '[]');
        this.newSurveysCount = this.surveys.filter(s => !seenIds.includes(s.surveyId)).length;
      },
      error: (err: any) => console.error('Load surveys for feed failed:', err)
    });
  }
  loadHolidaysForFeed(): void {
    this.hrmsService.getHolidays({ pageIndex: 1, pageSize: 100 }).subscribe({
      next: (res: any) => {
        const data: any[] = Array.isArray(res) ? res : res?.holidays ?? res?.data ?? [];
        const today = new Date(); today.setHours(0, 0, 0, 0);
        this.holidays = data
          .filter((h: any) => h.isPosted === true)
          .filter((h: any) => h.isActive)
          .filter((h: any) => { if (!h.holidayDate) return false; return new Date(h.holidayDate) >= today; })
          .map((h: any) => ({
            holidayId: h.holidayId,
            name: h.holidayName,
            description: h.description ?? '',
            date: h.holidayDate ? new Date(h.holidayDate) : null,
            type: h.holidayType ?? 'General',
            location: h.applicableLocation ?? '',
            isOptional: h.isOptional ?? false
          }))
          .sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());
        const seenIds: number[] = JSON.parse(localStorage.getItem('seenItems_holiday') || '[]');
        this.newHolidaysCount = this.holidays.filter(h => !seenIds.includes(h.holidayId)).length;
      },
      error: (err: any) => console.error('Load holidays for feed failed:', err)
    });
  }
  private getSurveyStatus(startDate: string, endDate: string): string {
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
    if (start && today < start) return 'Upcoming';
    if (end && today > end) return 'Closed';
    return 'Open';
  }
  markAsSeen(type: string): void {
    localStorage.setItem(`lastSeen${type}`, new Date().toISOString());
    if (type === 'Announcement') this.newAnnouncementsCount = 0;
    if (type === 'Survey') this.newSurveysCount = 0;
    if (type === 'Holiday') this.newHolidaysCount = 0;
  }
  get totalFeedCount(): number {
    return this.newAnnouncementsCount + this.newSurveysCount + this.newHolidaysCount;
  }
  openDetail(type: 'announcement' | 'survey' | 'holiday', item: any): void {
    this.detailType = type;
    this.detailItem = item;
    this.showDetailDialog = true;
    this.markItemAsSeen(type, item);
  }
  private markItemAsSeen(type: 'announcement' | 'survey' | 'holiday', item: any): void {
    const storageKey = `seenItems_${type}`;
    const seenIds: number[] = JSON.parse(localStorage.getItem(storageKey) || '[]');
    const itemId = type === 'announcement' ? item.announcementId
      : type === 'survey' ? item.surveyId
        : item.holidayId;
    if (seenIds.includes(itemId)) return;
    seenIds.push(itemId);
    localStorage.setItem(storageKey, JSON.stringify(seenIds));
    if (type === 'announcement' && this.newAnnouncementsCount > 0) this.newAnnouncementsCount--;
    if (type === 'survey' && this.newSurveysCount > 0) this.newSurveysCount--;
    if (type === 'holiday' && this.newHolidaysCount > 0) this.newHolidaysCount--;
  }
  closeDetail(): void {
    this.showDetailDialog = false;
    this.detailType = '';
    this.detailItem = null;
  }
  getAttachmentUrl(attachment: string): string {
    if (!attachment) return '';
    return attachment.startsWith('http') ? attachment : `https://localhost:8109${attachment}`;
  }
  
    myFiles: FileItem[] = [
    { id: 1, label: 'Aadhaar Card', name: 'Aadhaar Card', type: 'img', size: '—', uploadedAt: null },
    { id: 2, label: 'PAN Card', name: 'PAN Card', type: 'img', size: '—', uploadedAt: null },

    { id: 4, label: 'Graduation degree', name: 'Graduation degree', type: 'pdf', size: '—', uploadedAt: null },
    { id: 5, label: 'Postgraduate degree', name: 'Postgraduate degree', type: 'pdf', size: '—', uploadedAt: null },

    { id: 6, label: 'Resume', name: 'Resume', type: 'doc', size: '—', uploadedAt: null },
    { id: 7, label: 'Offer letter ', name: 'Offer letter ', type: 'pdf', size: '—', uploadedAt: null },
    { id: 8, label: 'Experience letters', name: 'Experience letters', type: 'pdf', size: '—', uploadedAt: null },

    { id: 9, label: 'Last three months salary slips', name: 'Last three months salary slips', type: 'pdf', size: '—', uploadedAt: null },
    { id: 10, label: 'Latest Form 16', name: 'Latest Form 16', type: 'pdf', size: '—', uploadedAt: null },
  ];
  sharedFiles: FileItem[] = [];
  filteredMyFiles: FileItem[] = [];
  filteredSharedFiles: FileItem[] = [];
  fileSearchQuery = '';
  activeFileFilter = 'all';
  myFilesView: 'grid' | 'list' = 'grid';
  fileFilters = [
    { label: 'All', value: 'all', icon: 'pi pi-folder' },
    { label: 'PDF', value: 'pdf', icon: 'pi pi-file-pdf' },
    { label: 'Docs', value: 'doc', icon: 'pi pi-file-word' },
    { label: 'Sheets', value: 'xls', icon: 'pi pi-file-excel' },
    { label: 'Images', value: 'img', icon: 'pi pi-image' },
  ];
  addNewExpense(): void {
    this.router.navigate(['/home/expense/create-expense']);
  }
  loadExpenseDashboardData(employeeId: string): void {
    if (!employeeId) return;
    const payload = { pageIndex: 0, pageSize: 1000 };
    this.hrmsService.getExpenseReimbursement(payload).subscribe({
      next: (res: any) => {
        let allExpenses: any[] = [];
        if (res?.expenses && Array.isArray(res.expenses)) {
          allExpenses = res.expenses;
        } else if (Array.isArray(res)) {
          allExpenses = res;
        }
        const myExpenses = allExpenses.filter((x: any) =>
          String(x.employeeId || '').trim().toUpperCase() ===
          String(employeeId || '').trim().toUpperCase()
        );
        this.dashboardData = {
          claimAmount: myExpenses
            .filter((x: any) => x.status !== 'Draft')
            .reduce((sum: number, item: any) => sum + (Number(item.amount) || 0), 0),
          approvedAmount: myExpenses
            .filter((x: any) => x.status === 'Approved')
            .reduce((sum: number, item: any) => sum + (Number(item.amount) || 0), 0),
          pendingAmount: myExpenses
            .filter((x: any) => x.status === 'Pending' || x.status === 'Submitted')
            .reduce((sum: number, item: any) => sum + (Number(item.amount) || 0), 0),
          rejectedAmount: myExpenses
            .filter((x: any) => x.status === 'Rejected')
            .reduce((sum: number, item: any) => sum + (Number(item.amount) || 0), 0),
          paidAmount: myExpenses
            .filter((x: any) => x.status === 'Paid')
            .reduce((sum: number, item: any) => sum + (Number(item.amount) || 0), 0),
          Expense: myExpenses.length
        };
      },
      error: (err) => console.error('Expense dashboard error', err)
    });
  }
  loadDashboardExpenses(employeeId?: string): void {
    const empId = employeeId || this.employeeId;
    const payload = { pageIndex: 0, pageSize: 1000 };
    this.hrmsService.getExpenseReimbursement(payload).subscribe({
      next: (res: any) => {
         console.log(res);
        let allExpenses: any[] = [];
        if (res?.expenses && Array.isArray(res.expenses)) {
          allExpenses = res.expenses;
        } else if (res?.Expenses && Array.isArray(res.Expenses)) {
          allExpenses = res.Expenses;
        } else if (Array.isArray(res)) {
          allExpenses = res;
        }
        this.zone.run(() => {

          if (employeeId) {
            this.recentExpenses = allExpenses.filter((x: any) =>
              String(x.employeeId || '').trim().toUpperCase() ===
              String(employeeId || '').trim().toUpperCase()
            );
          } else {
            this.recentExpenses = allExpenses;
          }

          
          this.allExpenses = [...this.recentExpenses];

        });
      },
      error: (err) => console.error('Dashboard expense load failed', err)
    });
  }
  resolveEmployeeFromUserId(userId: number): void {
    this.administratorService.getAllUser().subscribe({
      next: (users: any[]) => {
        const currentUser = users.find(u => u.userId === userId);
        console.log('Current User =>', currentUser);
        if (!currentUser?.empId) {
          console.warn('Employee ID not mapped to this user');
          return;
        }
        this.empId = Number(currentUser.empId);
        this.loggedInEmployeeId = currentUser.employeeId || '';
        console.log('Current User Employee ID =>', this.loggedInEmployeeId);
        this.loadExpenseDashboardData(this.loggedInEmployeeId);
        this.loadDashboardExpenses(this.loggedInEmployeeId);
        this.checkTodayAttendance();
        this.getShift();
        this.getAttendance();
        if (this.empId) {
          this.loadMyFilesFromApi();
        }
        this.hrmsService.getEmployeeByID(this.empId).subscribe({
          next: (res: any) => {
            const employee = res?.employee || res?.data || res?.result || res;
            if (!employee || !employee.employeeId) return;
            this.patchEmployee(employee);
          },
          error: err => console.error('Failed to load employee:', err)
        });
      },
      error: err => console.error('Failed to fetch users:', err)
    });
  }
    loadMyFilesFromApi(): void {
    this.loadSubmittedState();
    this.filteredMyFiles = [...this.myFiles];
    this.loadSharedFilesFromApi();
  }
  /** Reads which local file ids were previously submitted and re-applies
   * the `submitted` flag so the "Submitted" badge persists across reloads. */
  private loadSubmittedState(): void {
    try {
      const submittedIds: number[] = JSON.parse(localStorage.getItem('submittedFileIds') || '[]');
      this.myFiles.forEach(f => f.submitted = submittedIds.includes(f.id));
    } catch {
      // ignore malformed/missing storage
    }
  }
  /** Persists the current set of submitted local file ids to localStorage. */
  private saveSubmittedState(): void {
    const submittedIds = this.myFiles.filter(f => f.submitted).map(f => f.id);
    localStorage.setItem('submittedFileIds', JSON.stringify(submittedIds));
  }
  
  loadSharedFilesFromApi(): void {
    this.hrmsService.getSharedHrFiles().subscribe({
      next: (res: any) => {
        const all: any[] = Array.isArray(res) ? res : (res?.Data ?? res?.data ?? []);

        this.sharedFiles = all.map((f: any) => ({
          id: f.id,
          name: f.fileName ?? '—',
          type: (f.fileType ?? 'pdf').toLowerCase(),
          size: '—',
          uploadedAt: f.uploadDate ? new Date(f.uploadDate) : new Date(),
          fileId: f.id,
          sharedBy: undefined,
          filePath: f.filePath
        }));

        this.filteredSharedFiles = [...this.sharedFiles];
        this.applyFileFilters();
      },
      error: (err: any) => {
        console.error('Failed to load shared HR files:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Load Failed',
          detail: 'Could not load shared files.'
        });
      }
    });
  }
  checkTodayAttendance(): void {
    if (!this.empId) { console.warn('empId not available'); return; }
    const todayKey = this.getTodayKey();
    const payload = { pageIndex: 0, pageSize: 50, id: 0, empId: this.empId };
    this.hrmsService.getAttendanceEmpById(payload).subscribe({
      next: (data: any) => {
        const attendances: any[] = data?.attendances || [];
        const todayRecords = attendances.filter((a: any) => {
          if (!a?.date) return false;
          return (typeof a.date === 'string' ? a.date : new Date(a.date).toISOString())
            .split('T')[0] === todayKey;
        });
        if (!todayRecords.length) { this.resetAttendanceState(true); return; }
        const openRecord = todayRecords.find((a: any) => a.checkIn && !a.checkOut && a.status !== 'Rejected');
        const closedRecord = todayRecords.find((a: any) => a.checkIn && a.checkOut);
        if (closedRecord) { this.resetAttendanceState(false); return; }
        if (openRecord) {
          this.attendanceId = openRecord.attendanceId;
          this.todayAttendance = openRecord;
          this.currentWorkLocationType = openRecord.workLocationType || '';
          this.currentLocationName = openRecord.locationName || '';
          this.currentAttendanceStatus = openRecord.attendanceStatus || '';
          this.isPendingApproval = !!openRecord.requiresApproval;
          this.checkedIn = true;
          this.canCheckIn = false;
          this.canCheckOut = true;
          if (openRecord.checkIn) {
            const stored = localStorage.getItem('checkinTime');
            let start: Date | null = null;
            if (stored) {
              const storedDate = new Date(stored);
              if (storedDate.toDateString() === new Date().toDateString()) start = storedDate;
            }
            if (!start) {
              const normalised = openRecord.checkIn.split(':').length === 2
                ? openRecord.checkIn + ':00' : openRecord.checkIn;
              start = new Date(`${todayKey}T${normalised}`);
              if (!isNaN(start.getTime())) localStorage.setItem('checkinTime', start.toISOString());
            }
            if (start && !isNaN(start.getTime())) this.startTimer(start);
          }
        } else {
          this.resetAttendanceState(true);
        }
      },
      error: (err: any) => { console.error('Error checking today attendance:', err); this.resetAttendanceState(true); }
    });
  }
  private resetAttendanceState(canCheckInAgain: boolean): void {
    clearInterval(this.timer);
    this.checkedIn = false;
    this.canCheckIn = canCheckInAgain;
    this.canCheckOut = false;
    this.hours = this.minutes = this.seconds = 0;
    this.attendanceId = null;
    this.todayAttendance = null;
    this.currentWorkLocationType = '';
    this.currentLocationName = '';
    this.currentAttendanceStatus = '';
    this.isPendingApproval = false;
    localStorage.removeItem('checkinTime');
  }
  onCheckIn(): void {
    if (this.isCheckingIn) return;
    if (!this.empId || this.empId <= 0) {
      this.messageService.add({ severity: 'warn', summary: 'Employee Not Mapped', detail: 'Your employee details are not mapped. Please contact admin.' });
      return;
    }
    if (!this.canCheckIn) {
      this.messageService.add({ severity: 'warn', summary: 'Already Completed', detail: 'Attendance is already completed for today.' });
      return;
    }
    if (this.checkedIn) {
      this.messageService.add({ severity: 'info', summary: 'Already Checked In', detail: 'You are already checked in for today.' });
      return;
    }
    if (!navigator.geolocation) {
      this.messageService.add({ severity: 'error', summary: 'GPS Not Supported', detail: 'Your browser does not support geolocation.' });
      return;
    }
    this.isCheckingIn = true;
    this.messageService.add({ severity: 'info', summary: 'Locating...', detail: 'Fetching your GPS location.' });
    navigator.geolocation.getCurrentPosition(
      (position) => this.performCheckIn(position),
      (error) => { this.handleGeoError(error); this.isCheckingIn = false; },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }
  private performCheckIn(position: GeolocationPosition): void {
    const acc = position.coords.accuracy;
    if (acc > 1000) {
      this.messageService.add({ severity: 'warn', summary: 'Low GPS Accuracy', detail: `Accuracy is ${Math.round(acc)}m. Check-in may require admin approval.` });
    }
    const req = {
      empId: this.empId,
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      shift: this.shiftName || null,
      createdBy: this.employeeName
    };
    this.hrmsService.locationCheckIn(req).subscribe({
      next: (result: any) => {
        if (result?.success) {
          const now = new Date();
          this.checkedIn = true;
          this.canCheckIn = false;
          this.canCheckOut = true;
          this.attendanceId = result.attendanceId;
          this.currentWorkLocationType = result.workLocationType || '';
          this.currentLocationName = result.locationName || '';
          this.currentAttendanceStatus = result.attendanceStatus || '';
          this.isPendingApproval = !!result.requiresApproval;
          localStorage.setItem('checkinTime', now.toISOString());
          this.startTimer(now);
          this.messageService.add({
            severity: result.requiresApproval ? 'warn' : 'success',
            summary: result.requiresApproval ? 'Pending Approval' : 'Checked In',
            detail: result.message, life: 6000
          });
          setTimeout(() => this.checkTodayAttendance(), 1000);
        } else {
          this.isCheckingIn = false;
          this.messageService.add({ severity: 'error', summary: 'Check-in Failed', detail: result?.message || 'Check-in failed. Please try again.', life: 7000 });
        }
      },
      error: (err: any) => {
        console.error('Check-in error:', err);
        this.isCheckingIn = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Check-in request failed. Please try again.' });
      }
    });
  }
  confirmCheckout(): void {
    if (!this.checkedIn) {
      this.messageService.add({ severity: 'warn', summary: 'Cannot Check Out', detail: 'You must check in first before checking out.' });
      return;
    }
    this.confirmationService.confirm({
      header: 'Confirm Checkout',
      message: 'Are you sure you want to check out?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.performCheckOut(),
      reject: () => { }
    });
  }
  private performCheckOut(): void {
    if (!navigator.geolocation) {
      this.messageService.add({ severity: 'error', summary: 'GPS Not Supported', detail: 'Your browser does not support geolocation.' });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        if (!this.attendanceId) {
          this.messageService.add({ severity: 'error', summary: 'Check-out Failed', detail: 'No attendance record found. Please contact admin.' });
          return;
        }
        const req = {
          attendanceId: this.attendanceId,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          updatedBy: this.employeeName
        };
        this.hrmsService.locationCheckOut(req).subscribe({
          next: (result: any) => {
            if (result?.success) {
              this.resetAttendanceState(false);
              this.messageService.add({ severity: 'info', summary: 'Checked Out', detail: result?.message || 'Checked out successfully.' });
              setTimeout(() => { this.checkTodayAttendance(); this.getAttendance(); }, 500);
            } else {
              this.messageService.add({ severity: 'error', summary: 'Check-out Failed', detail: result?.message || 'Check-out failed. Please try again.' });
            }
          },
          error: (err: any) => {
            console.error('Check-out error:', err);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Check-out request failed. Please try again.' });
          }
        });
      },
      (error) => this.handleGeoError(error),
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
    );
  }
  private handleGeoError(error: GeolocationPositionError): void {
    let detail = 'Unable to get your location.';
    if (error.code === 1) detail = 'Location permission denied. Please enable location access in your browser settings.';
    else if (error.code === 2) detail = 'Location unavailable. Please check your GPS/network connection.';
    else if (error.code === 3) detail = 'Location request timed out. Please try again.';
    this.messageService.add({ severity: 'error', summary: 'Location Error', detail, life: 7000 });
  }
  startTimer(startTime: Date): void {
    if (this.timer) clearInterval(this.timer);
    const update = () => {
      const diff = new Date().getTime() - startTime.getTime();
      if (diff < 0) { this.hours = 0; this.minutes = 0; this.seconds = 0; return; }
      this.hours = Math.floor(diff / (1000 * 60 * 60));
      this.minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((diff % (1000 * 60)) / 1000);
    };
    update();
    this.timer = setInterval(update, 1000);
  }
  handleDayChange(): void {
    const lastCheckin = localStorage.getItem('checkinTime');
    const lastDate = lastCheckin ? new Date(lastCheckin).toDateString() : null;
    const today = new Date().toDateString();
    if (lastDate && lastDate !== today) {
      this.resetAttendanceState(true);
      if (this.empId) this.checkTodayAttendance();
      this.hrmsService.getEmployees(this.pageRequest).subscribe({
        next: (res: any) => this.loadBirthdayEmployees(res?.employees || []),
        error: err => console.error(err)
      });
      this.loadTodayLeavesAndWFH();
    }
  }
  getAttendance(): void {
    if (!this.empId) return;
    this.loader = true;
    const payload = { pageIndex: 0, pageSize: 200, id: 0, empId: this.empId };
    this.hrmsService.getAttendanceEmpById(payload).subscribe({
      next: (data: any) => {
        this.AttendanceList = data?.attendances || [];
        this.loadAttendanceAsEvents();
        this.loader = false;
      },
      error: () => {
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load attendance data.' });
      }
    });
  }
  loadAttendanceAsEvents(): void {
    if (!this.AttendanceList?.length) { this.calendarOptions.events = []; return; }
    this.calendarOptions.events = this.AttendanceList.map((att: any) => {
      const title = att.checkIn && att.checkOut
        ? `✓ In: ${att.checkIn} | Out: ${att.checkOut}`
        : att.checkIn ? `✓ In: ${att.checkIn} | Pending` : `Status: ${att.status || 'N/A'}`;
      const color = att.checkIn && att.checkOut ? '#10b981' : att.checkIn ? '#f59e0b' : '#9ca3af';
      return { title, date: att.date, backgroundColor: color, borderColor: color, textColor: '#ffffff', id: att.attendanceId };
    });
  }
  handleCalendarClick(arg: any): void {
    const attendance = this.AttendanceList.find(a => a.attendanceId == arg.event.id);
    if (!attendance) return;
    const totalHours = this.formatTotalHours(attendance.totalHours, attendance.checkIn, attendance.checkOut);
    const d = new Date(attendance.date);
    const formattedDate = `${('0' + d.getDate()).slice(-2)}/${('0' + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`;
    this.zone.run(() => {
      this.messageService.add({
        severity: 'info', summary: 'Attendance Details',
        detail: `Date: ${formattedDate} | In: ${attendance.checkIn || 'N/A'} | Out: ${attendance.checkOut || 'N/A'} | Hours: ${totalHours}`
      });
    });
  }
  patchEmployee(employee: Employee): void {
    if (!employee || Object.keys(employee).length === 0) {
      console.warn('Employee data is null or undefined');
      return;
    }
    this.employeeId = employee.employeeId || '';
    this.employeeName = `${employee.firstName || ''} ${employee.lastName || ''}`.trim();
    this.Designation = employee.designation || '';
    this.shiftName = employee.shiftName || '';
    this.employeeForm.patchValue({
      employeeId: employee.employeeId || '',
      firstName: employee.firstName || '',
      lastName: employee.lastName || '',
      prefix: employee.prefix || '',
      email: employee.email || '',
      phone: employee.phone || '',
      mobile: employee.mobile || '',
      address: {
        addressLine1: employee.address?.addressLine1 || '',
        addressLine2: employee.address?.addressLine2 || '',
        city: employee.address?.city || '',
        state: employee.address?.state || '',
        zip: employee.address?.zip || '',
        country: employee.address?.country || 'India',
      },
      designation: employee.designation || '',
      jobRole: employee.jobRole || '',
      work_Email: employee.work_Email || '',
      employmentType: employee.employmentType || '',
      employeeStatus: employee.employeeStatus || '',
      location: employee.location || '',
      dateOfJoining: employee.dateOfJoining ? new Date(employee.dateOfJoining) : null,
      gender: employee.gender || '',
      dob: employee.dob ? new Date(employee.dob) : null,
      website: employee.website || '',
      facebook: employee.facebook || '',
      twitter: employee.twitter || '',
      instituteName: employee.instituteName || '',
      degree: employee.degree || '',
      specialization: employee.specialization || '',
      completionYear: employee.completionYear || '',
      internalNotes: employee.internalNotes || '',
      ShiftId: employee.shiftId || null,
      ShiftName: employee.shiftName || '',
    });
    if (employee.reportingManager && typeof employee.reportingManager === 'string') {
      const managerIds = employee.reportingManager
        .split(',')
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id) && id > 0);
      this.employeeForm.controls.reportingManager.setValue(managerIds);
      this.reportees = managerIds.map(id => {
        const emp = this.employeeList.find(e => e.value === id);
        return {
          name: emp?.label || 'Unknown',
          image: 'assets/person-logo.jpg',
          designation: emp?.designation || '—',
          dob: null as unknown as Date,
          status: this.getTodayStatus(id)
        };
      });
    } else {
      this.employeeForm.controls.reportingManager.setValue([]);
      this.reportees = [];
    }
    if (employee.dob) {
      const d = new Date(employee.dob);
      const now = new Date();
      this.isMyBirthdayToday = d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
    } else {
      this.isMyBirthdayToday = false;
    }
  }
  getShift(): void {
    this.hrmsService.getShift(this.pageRequest).subscribe({
      next: (data: any) => {
        this.shiftDropdown = (data.employeeShifts || []).map((shift: any) => ({
          ...shift,
          label: `${shift.shiftName} (${this.formatTime(shift.fromTime)} - ${this.formatTime(shift.toTime)})`
        }));
      },
      error: err => console.error(err)
    });
  }
  getCompanyDetails(): void {
    this.administratorService.getCompanyDetails().subscribe({
      next: (data: any) => {
        if (data?.length > 0) {
          const company = data[0];
          this.companyName = company.companyName;
          this.companyLogo = company.companyLogo ? `data:image/jpeg;base64,${company.companyLogo}` : 'null';
        }
      },
      error: err => console.error('Company fetch error:', err)
    });
  }
  loadTodayLeavesAndWFH(): void {
    this.loadingLeaves = true;
    const today = new Date(); today.setHours(0, 0, 0, 0);
    this.hrmsService.getLeave(this.pageRequest).subscribe({
      next: (res: any) => {
        const all = Array.isArray(res) ? res : (res?.leaves || []);
        const todayLeavesList = all.filter((leave: any) => {
          if (leave.status !== 'Approved' || leave.leaveType === 'Work From Home') return false;
          const from = new Date(leave.fromDate); from.setHours(0, 0, 0, 0);
          const end = new Date(leave.endDate); end.setHours(23, 59, 59, 999);
          return today >= from && today <= end;
        });
        const todayWFHList = all.filter((leave: any) => {
          if (leave.status !== 'Approved' || leave.leaveType !== 'Work From Home') return false;
          const from = new Date(leave.fromDate); from.setHours(0, 0, 0, 0);
          const end = new Date(leave.endDate); end.setHours(23, 59, 59, 999);
          return today >= from && today <= end;
        });
        this.enrichLeaveData(todayLeavesList, todayWFHList);
        this.loadingLeaves = false;
      },
      error: err => { console.error('Error loading leaves:', err); this.loadingLeaves = false; }
    });
  }
  enrichLeaveData(leaves: any[], wfh: any[]): void {
    const empIds = [...new Set([...leaves.map(l => l.empId), ...wfh.map(w => w.empId)])];
    if (!empIds.length) { this.todayLeaves = []; this.todayWFH = []; return; }
    forkJoin(empIds.map(id =>
      this.hrmsService.getEmployeeByID(id).pipe(map((emp: any) => ({ id, emp })))
    )).subscribe({
      next: (results: any) => {
        const empMap = new Map();
        results.forEach(({ id, emp }: any) => {
          if (emp) empMap.set(emp.empId || id, {
            name: `${emp.firstName} ${emp.lastName || ''}`.trim(),
            designation: emp.designation || 'N/A',
            image: 'assets/person-logo.jpg'
          });
        });
        const enrich = (item: any) => {
          const e = empMap.get(item.empId);
          return { ...item, employeeName: e?.name || 'Unknown', designation: e?.designation || 'N/A', image: e?.image || 'assets/person-logo.jpg' };
        };
        this.todayLeaves = leaves.map(enrich);
        this.todayWFH = wfh.map(enrich);
      },
      error: err => {
        console.error('Error enriching leave data:', err);
        this.todayLeaves = leaves.map(l => ({ ...l, employeeName: 'Unknown', designation: 'N/A', image: 'assets/person-logo.jpg' }));
        this.todayWFH = wfh.map(w => ({ ...w, employeeName: 'Unknown', designation: 'N/A', image: 'assets/person-logo.jpg' }));
      }
    });
  }
  loadBirthdayEmployees(employees: any[]): void {
    if (!employees?.length) { this.birthdayEmployees = []; this.filteredBirthdays = []; return; }
    const todayMonth = new Date().getMonth() + 1;
    this.birthdayEmployees = employees
      .filter(emp => { try { return emp.dob && new Date(emp.dob).getMonth() + 1 === todayMonth; } catch { return false; } })
      .map(emp => ({ empId: emp.empId, name: `${emp.firstName} ${emp.lastName}`, designation: emp.designation, image: 'assets/person-logo.jpg', dob: emp.dob }));
    this.filterBirthdayList();
  }
  filterBirthdayList(manualSelection = false): void {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();
    const todayBirthdays = this.birthdayEmployees.filter(emp => {
      if (!emp.dob) return false;
      const d = new Date(emp.dob);
      return d.getMonth() + 1 === currentMonth && d.getDate() === currentDay;
    });
    this.birthdaysToday = todayBirthdays;
    this.isMyBirthdayToday = todayBirthdays.some(b => b.empId === this.empId);
    if (!manualSelection) {
      if (todayBirthdays.length > 0) {
        this.selectedBirthdayFilter = 'today';
        this.filteredBirthdays = todayBirthdays;
        this.triggerFireworks();
        this.triggerConfetti();
      } else {
        this.selectedBirthdayFilter = 'month';
        this.filteredBirthdays = this.birthdayEmployees;
      }
      return;
    }
    this.filteredBirthdays = this.selectedBirthdayFilter === 'today' ? todayBirthdays : this.birthdayEmployees;
  }
  triggerFireworks(): void {
    const duration = 2000;
    const end = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };
    const interval = setInterval(() => {
      const timeLeft = end - Date.now();
      if (timeLeft <= 0) { clearInterval(interval); return; }
      confetti({ ...defaults, particleCount: 50 * (timeLeft / duration), origin: { x: Math.random(), y: Math.random() } });
    }, 250);
  }
  triggerConfetti(): void {
    confetti({ particleCount: 100, spread: 70, origin: { x: 0.5, y: 0.5 } });
  }
  private getTodayKey(): string {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }
  getTodayStatus(empId: number): 'Active' | 'Inactive' {
    const key = this.getTodayKey();
    const rec = this.AttendanceList.find(a => a.empId === empId && a.date?.startsWith(key));
    return rec?.status === 'Checked In' ? 'Active' : 'Inactive';
  }
  getWorkTypeBadgeSeverity(workType: string): string {
    switch (workType) {
      case 'Office': return 'success';
      case 'Unit': return 'info';
      case 'Remote': return 'warning';
      default: return 'secondary';
    }
  }
  getWorkTypeIcon(workType: string): string {
    switch (workType) {
      case 'Office': return 'pi pi-building';
      case 'Unit': return 'pi pi-map-marker';
      case 'Remote': return 'pi pi-home';
      default: return 'pi pi-question';
    }
  }
  getLeaveTypeClass(leaveType: string): string {
    const t = (leaveType || '').toLowerCase();
    if (t.includes('sick')) return 'leave-type-sick';
    if (t.includes('casual')) return 'leave-type-casual';
    if (t.includes('maternity')) return 'leave-type-maternity';
    if (t.includes('paternity')) return 'leave-type-paternity';
    if (t.includes('lop') || t.includes('lwp') || t.includes('loss')) return 'leave-type-lop';
    return 'leave-type-default';
  }
  getDurationClass(duration: string): string {
    const d = (duration || '').toLowerCase();
    if (d.includes('first half')) return 'duration-first-half';
    if (d.includes('second half')) return 'duration-second-half';
    return 'duration-full-day';
  }
  getDurationIcon(duration: string): string {
    const d = (duration || '').toLowerCase();
    if (d.includes('first half')) return 'pi pi-sun';
    if (d.includes('second half')) return 'pi pi-moon';
    return 'pi pi-calendar';
  }
  setGreetingAndQuote(): void {
    const h = new Date().getHours();
    if (h >= 5 && h < 12) { this.greeting = 'Good Morning'; this.quote = 'Rise and shine! A productive day awaits.'; }
    else if (h >= 12 && h < 17) { this.greeting = 'Good Afternoon'; this.quote = 'Keep going strong, the day is still young!'; }
    else if (h >= 17 && h < 21) { this.greeting = 'Good Evening'; this.quote = 'Relax, reflect, and recharge for tomorrow.'; }
    else { this.greeting = 'Good Night'; this.quote = 'Time to rest and rejuvenate for a new day.'; }
  }
  formatTime(time: string): string {
    const [hour, minute] = time.split(':').map(Number);
    const period = hour >= 12 ? 'PM' : 'AM';
    return `${hour % 12 || 12}:${minute.toString().padStart(2, '0')} ${period}`;
  }
  formatTotalHours(totalHours: number | string | null, checkIn?: string, checkOut?: string): string {
    let secs = 0;
    if (totalHours != null && totalHours !== '') {
      const h = typeof totalHours === 'string' ? parseFloat(totalHours) : totalHours;
      if (!isNaN(h)) secs = Math.round(h * 3600);
    }
    if (secs === 0 && checkIn && checkOut) {
      try {
        const base = '1970-01-01T';
        const diff = new Date(base + checkOut).getTime() - new Date(base + checkIn).getTime();
        if (diff > 0) secs = Math.round(diff / 1000);
      } catch (e) { console.error(e); }
    }
    if (secs <= 0) return '—';
    const h = Math.floor(secs / 3600);
    const m = Math.floor((secs % 3600) / 60);
    const s = secs % 60;
    return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')} hrs`;
  }
  onTabChange(event: any): void {
    this.getAttendance();
    if (event.index === 3 && this.loggedInEmployeeId) {
      this.zone.run(() => {
        this.loadDashboardExpenses(this.loggedInEmployeeId);
        this.loadExpenseDashboardData(this.loggedInEmployeeId);
      });
    }
  }
  setView(view: 'calendar'): void { this.layoutType = view; this.loadAttendanceAsEvents(); }
  onDatesSet(_arg: any): void { }
  get formControls() { return this.employeeForm.controls; }
  cancel(): void { this.router.navigate(['/home/crmcontactlist']); }
  goToExpenseList(): void {
    this.router.navigate(['/home/expense']);
  }
  openExpenseDetail(row: any): void {
    this.router.navigate(
      ['/home/expense/create-expense'],
      { queryParams: { id: row.id, hideApproval: true } }
    );
  }
  expenseList: any[] = [];
  selectedExpenses: any[] = [];
  searchExpense(): void {
    const query = this.searchText?.toLowerCase().trim() || '';
    if (!query) {
      this.recentExpenses = [...this.allExpenses];
      return;
    }

    this.recentExpenses = this.allExpenses.filter((expense: any) => {

      const amountMatch = String(expense.amount || '') === query;


      const typeMatch = (expense.expenseType || '').toLowerCase().includes(query);
      const descMatch = (expense.description || '').toLowerCase().includes(query);
      const dateMatch = expense.expenseDate

        ? new Date(expense.expenseDate).toLocaleDateString('en-GB').includes(query)
        : false;
      const advanceMatch = (expense.isAdvanceReceived ? 'yes' : 'no').includes(query)
      return amountMatch || typeMatch || descMatch || dateMatch || advanceMatch;
    });
  }
  loadExpenses(event?: any): void { }
  editExpense(expense?: any): void { }
  deleteExpense(): void { }
  getExpenseTypeIcon(type: string): string {
    const map: any = {
      'Travel Expenses': 'pi pi-car',
      'Food & Meals': 'pi pi-star',
      'Accommodation': 'pi pi-home',
      'Medical Expenses': 'pi pi-heart',
      'Office Supplies': 'pi pi-briefcase',
      'Training & Courses': 'pi pi-book',
      'Communication': 'pi pi-phone',
      'Other': 'pi pi-tag'
    };
    return map[type] || 'pi pi-tag';
  }
  refreshExpenseData(): void {
    this.loadDashboardExpenses(this.loggedInEmployeeId);
    this.loadExpenseDashboardData(this.loggedInEmployeeId);
  }
  loadExpense(event?: any): void { this.loadExpenses(event); }
  onFileSearch(): void { this.applyFileFilters(); }
  setFileFilter(value: string): void {
    this.activeFileFilter = value;
    this.applyFileFilters();
  }
  private applyFileFilters(): void {
    const q = this.fileSearchQuery.toLowerCase().trim();
    const type = this.activeFileFilter;
    const match = (f: FileItem) =>
      (type === 'all' || f.type === type) &&
      (!q || f.name.toLowerCase().includes(q));
    this.filteredMyFiles = this.myFiles.filter(match);
    this.filteredSharedFiles = this.sharedFiles.filter(match);
  }
  getFileColorClass(type: string): string {
    const map: Record<string, string> = {
      pdf: 'file-icon-pdf', doc: 'file-icon-doc', xls: 'file-icon-xls',
      img: 'file-icon-img', zip: 'file-icon-zip', video: 'file-icon-video',
    };
    return map[type] ?? 'file-icon-default';
  }
  getFileIcon(type: string): string {
    const map: Record<string, string> = {
      pdf: 'pi pi-file-pdf', doc: 'pi pi-file-word', xls: 'pi pi-file-excel',
      img: 'pi pi-image', zip: 'pi pi-file-zip', video: 'pi pi-video',
    };
    return map[type] ?? 'pi pi-file';
  }
  openFile(file: FileItem): void {
    if (!file.fileId) {
      this.messageService.add({ severity: 'info', summary: 'Preview', detail: `No file available for "${file.name}"` });
      return;
    }

    const newTab = window.open('', '_blank');

    this.hrmsService.downloadSharedHrFile(file.fileId).subscribe({
      next: (blob: Blob) => {
        const objectUrl = URL.createObjectURL(blob);
        if (newTab) newTab.location.href = objectUrl;
        setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
      },
      error: () => {
        if (newTab) newTab.close();
        this.messageService.add({ severity: 'error', summary: 'Preview Failed', detail: 'Could not open file.' });
      }
    });
  }
  downloadFile(file: FileItem): void {
    if (!file.fileId) {
      this.messageService.add({ severity: 'warn', summary: 'Download', detail: `No file available for "${file.name}"` });
      return;
    }

    this.hrmsService.downloadSharedHrFile(file.fileId).subscribe({
      next: (blob: Blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Download Failed', detail: 'Could not download file.' });
      }
    });
  }
 	 clearFile(file: FileItem): void {
    if (!file.fileId && !file.pendingFile) {
      this.messageService.add({
        severity: 'info',
        summary: 'No File',
        detail: `"${file.label}" has nothing to remove.`
      });
      return;
    }


    this.confirmationService.confirm({
      header: 'Remove File',
     
      message: `Remove the uploaded file for "${file.name}"? You can upload again afterwards.`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const index = this.myFiles.findIndex(f => f.id === file.id);
        if (index > -1) {
         this.myFiles[index].pendingFile = undefined;
          this.myFiles[index].size = '—';
          this.myFiles[index].uploadedAt = null;
          this.myFiles[index].name = this.myFiles[index].label ?? this.myFiles[index].name;
          
          this.myFiles[index].submitted = false;
          this.applyFileFilters();
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Removed',
          detail: `"${file.label}" has been cleared.`
        });
      },
      reject: () => { }
    });
  }
  uploadFile(file: FileItem): void {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '*/*';

    input.onchange = (event: any) => {
      const selectedFile: File = event.target.files[0];
      if (!selectedFile) return;

      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('fileName', file.name);
      formData.append('employeeId', String(this.empId));
      formData.append('fileName', file.name);
      formData.append('visibility', 'Employee');
      formData.append('createdBy', this.username);

      this.hrmsService.uploadAndSaveFile(formData).subscribe({
        next: (res: any) => {
       const index = this.myFiles.findIndex(f => f.id === file.id);
      if (index > -1) {
        this.myFiles[index].pendingFile = selectedFile;
        // Show the card's fixed label plus the chosen file's real name,
        // e.g. "Aadhaar Card - passport_scan.jpg".
        this.myFiles[index].name = `${this.myFiles[index].label} - ${selectedFile.name}`;
        this.myFiles[index].size = this.formatFileSize(selectedFile.size);
        this.myFiles[index].uploadedAt = new Date();
        // Any previously submitted copy of this document is now stale
        // until the newly chosen file is submitted again.
        this.myFiles[index].submitted = false;
        this.saveSubmittedState();
        this.applyFileFilters();
      }
         this.messageService.add({
        severity: 'info',
        summary: 'File Selected',
        detail: `"${selectedFile.name}" is ready — click Submit to save it.`
          });
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Upload Failed',
            detail: err?.error?.message || 'File upload failed.'
          });
        }
      });
    };

    input.click();
  }
 submitFiles(): void {
    const pendingDocs = this.myFiles.filter(f => f.pendingFile);

    if (!pendingDocs.length) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Files',
        detail: 'Please choose at least one document before submitting.'
      });
      return;
    }


  // This is the ONLY place a file is actually sent to the server.
    // Selecting a file via the Upload button (see uploadFile()) only
    // stages it locally — clicking Submit here is what saves it.
    const uploads$ = pendingDocs.map(f => {
      const formData = new FormData();
      formData.append('file', f.pendingFile as File);
      formData.append('fileName', f.label ?? f.name);
      formData.append('employeeId', String(this.empId));
      formData.append('visibility', 'Employee');
      formData.append('createdBy', this.username);
      return this.hrmsService.uploadAndSaveFile(formData).pipe(
        map((res: any) => ({ item: f, res, error: null as any })),
        catchError(err => of({ item: f, res: null as any, error: err }))
      );
    });

    forkJoin(uploads$).subscribe((results: any[]) => {
      let successCount = 0;
      let failCount = 0;

      results.forEach(({ item, res, error }: any) => {
        const index = this.myFiles.findIndex(f => f.id === item.id);
        if (index === -1) return;

        if (error) {
          failCount++;
          return;
        }

        // IMPORTANT: only `fileId` carries the server reference; the
        // local `id` is never overwritten (see earlier fix notes).
        this.myFiles[index].fileId = res.id;
        this.myFiles[index].filePath = res.filePath;
        this.myFiles[index].submitted = true;
        this.myFiles[index].pendingFile = undefined;
        successCount++;
      });

      this.saveSubmittedState();
      this.applyFileFilters();

      if (successCount > 0) {
        this.messageService.add({
          severity: 'success',
          summary: 'Submitted',
          detail: `${successCount} document${successCount !== 1 ? 's' : ''} submitted successfully.`
        });
      }
      if (failCount > 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Submit Failed',
          detail: `${failCount} document${failCount !== 1 ? 's' : ''} could not be submitted. Please try again.`
        });
      }
    });
  }
  private formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  
  deleteMyFile(file: FileItem): void {
    this.confirmationService.confirm({
      header: 'Delete File',
      message: `Are you sure you want to delete "${file.name}"?`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.myFiles = this.myFiles.filter((f) => f.id !== file.id);
        this.filteredMyFiles = this.filteredMyFiles.filter((f) => f.id !== file.id);
        this.messageService.add({ severity: 'success', summary: 'Deleted', detail: `"${file.name}" has been removed.` });
      },
    });
  }
}